import { render } from "./crypto.vue?vue&type=template&id=9a1af782&scoped=true"
import script from "./crypto.vue?vue&type=script&lang=js"
export * from "./crypto.vue?vue&type=script&lang=js"

import "./crypto.vue?vue&type=style&index=0&id=9a1af782&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1af782"]])

export default __exports__